export class Template {
  idDaal:number;
  source:string;
  isPublish:boolean;
  isLive:boolean;
}
